/**
 * 安全工具类
 */

/**
 * HTML转义，防止XSS攻击
 * @param {string} text - 要转义的文本
 * @returns {string} 转义后的文本
 */
export function escapeHtml(text) {
    if (!text) return '';
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
}

/**
 * 安全地处理消息内容，转义HTML但保留表情符号
 * @param {string} message - 原始消息
 * @param {function} emojiProcessor - 表情符号处理函数
 * @returns {string} 处理后的消息
 */
export function sanitizeMessage(message, emojiProcessor) {
    if (!message) return '';
    // 先转义HTML
    let safeMessage = escapeHtml(message);
    // 然后处理表情符号（表情符号是安全的，因为是我们自己定义的）
    if (emojiProcessor) {
        safeMessage = emojiProcessor(safeMessage);
    }
    return safeMessage;
}

/**
 * 验证消息长度
 * @param {string} message - 消息内容
 * @param {number} maxLength - 最大长度，默认5000
 * @returns {boolean} 是否有效
 */
export function validateMessageLength(message, maxLength = 5000) {
    if (!message) return false;
    return message.length <= maxLength;
}

